import env from "../tools/Environment";
import UrlParams from "../tools/UrlParams";

/**
 * It's copy-past from pc.warface.com
 * @returns {{top: number, left: number, width: number, height: number}}
 */
function getWindowPosition() {
  let w = 504,
    h = 500;

  let dualScreenLeft =
      typeof window.screenLeft !== "undefined" ? window.screenLeft : window.screenX,
    dualScreenTop = typeof window.screenTop !== "undefined" ? window.screenTop : window.screenY,
    width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width,
    height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height,
    systemZoom = width / window.screen.availWidth,
    left = (width - w) / 2 / systemZoom + dualScreenLeft,
    top = (height - h) / 2 / systemZoom + dualScreenTop - 100;
  return {
    left,
    top,
    width: w / systemZoom,
    height: h / systemZoom,
  };
}

class OauthManager {
  constructor(config) {
    this.config = config;
    this.base_url = this.getBaseUrl();
    this.oauth_window = null;
    this.oauth_method = "signup";
    this.social_ep_list = this.config.getConfig().social_ep_list.join(",") || "false";
  }

  /**
   *
   * @param signup
   * @param force force_signup_social param to oauth (show only mailru/vk/smth EP)
   */
  showWindow(signup = false, force = null) {
    let method = signup ? "signup" : "signin";
    if (this.oauth_window && !this.oauth_window.closed) {
      if (method !== this.oauth_method) {
        this.oauth_window.location = this.getOauthUrl(signup, force);
      }
      this.oauth_window.focus();
    } else {
      this.oauth_window = window.open(
        this.getOauthUrl(signup, force),
        "Account",
        this.getWindowParams()
      );
    }
  }
  getBaseUrl() {
    const territory = env.getTerritory();
    const base_urls_list = {
      [env.MYGAMES]: "https://account.my.games/oauth2",
      [env.MAILRU]: "https://account.vkplay.ru/oauth2",
      [env.VKPLAY]: "https://account.vkplay.ru/oauth2",
    };
    const default_base_url = "https://account.my.games/oauth2";
    if (territory in base_urls_list) {
      return base_urls_list[territory];
    } else {
      if (console) {
        console.error(
          "Trying to use default_base_url. It can be a sign of error, please check your territory settings",
          default_base_url
        );
      }
      return default_base_url;
    }
  }

  /**
   * Oauth redirect url looks like this <AUTH_HOST>?param1&param2&...&redirect_uri=URLENCODED(host?destination=destination)
   * @param {number|null} signup
   * @param {string|null} force
   * @param {number|null} skip_grants
   * @param {string|null} destination
   * @param {string|null} host base redirect_uri host
   * @returns {string}
   */
  getOauthUrl(signup = null, force = null, skip_grants = null, destination = null, host = null) {
    return (
      this.base_url +
      "?" +
      UrlParams.urlFromObject(this.getUrlParams(signup, force, skip_grants, destination, host))
    );
  }
  getUrlParams(signup = null, force = null, skip_grants = null, destination = null, host = null) {
    let params = {
      client_id: window.__GEMS.client_id,
      redirect_uri: this.getRedirectUrl(destination, host),
      response_type: "code",
      signup_method: "email,phone",
      signup_social: this.social_ep_list,
      lang: env.getPosixLocale(),
    };
    skip_grants =
      skip_grants || (this.config.getConfig().auth && this.config.getConfig().auth.skip_grants);

    const optional_params = {
      gc_id: this.config.getConfig().project_reg.gc_id_in_auth ? window.__GEMS.gc_id : null,
      signup: signup ? 1 : null,
      force_signup_social: force ? force : null,
      client_name: window.__GEMS.client_name ? window.__GEMS.client_name : null,
      show_auth_btn: window.__GEMS.show_auth_btn ? window.__GEMS.show_auth_btn : null,
      skip_grants: skip_grants ? 1 : null,
      // Param app_client_id should have json format
      // Example: app_client_id={"xbox":"XBOX_APP_ID"}
      app_client_id: window.__GEMS.app_client_id
        ? JSON.stringify(window.__GEMS.app_client_id)
        : null,
    };
    //merge optional_params to params (if param exists and not null)
    for (let param in optional_params) {
      if (optional_params.hasOwnProperty(param) && optional_params[param] !== null) {
        params[param] = optional_params[param];
      }
    }
    return params;
  }
  getWindowParams() {
    let params = Object.assign(
      {
        resizable: "no",
        scrollbars: "no",
        toolbar: "no",
        menubar: "no",
        directories: "no",
        location: "no",
      },
      getWindowPosition()
    );
    return UrlParams.urlFromObject(params, ",");
  }

  getRedirectUrl(destination = null, host = null) {
    const DOMAIN = host || location.origin;
    let redirect_url = `${DOMAIN}/gw/oauth/mygames`;
    if (destination) {
      redirect_url += "?" + UrlParams.urlFromObject({ destination });
    }
    return redirect_url;
  }
}
export default OauthManager;
